// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      fieldset {
        border: none !important;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/administration/users-roles/edit-user/edit-user.component.ts"],"names":[],"mappings":";MACM;QACE,uBAAuB;MACzB","sourcesContent":["\n      fieldset {\n        border: none !important;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
